// ----------------------------------------------------------------------------
// Component: Page Header
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';
import 'snippets/video-player/video-block'; //if using page-header--video

// Styles
import './_page-header.scss';

// -------------------------------------
// Variables
// -------------------------------------
const PAGE_HERO = '.page-hero';
const PAGE_HERO_DESC = '.js--page-hero-hero-desc';

function adjustMarginBottom() {
    // Check if the screen width is 1023px or larger
    if (window.innerWidth >= 1023) {
        document.querySelectorAll(PAGE_HERO_DESC)?.forEach(element => {
            // Get the height of each element
            const elementHeight = element.offsetHeight;
            // Set the margin-bottom equal to the height
            element.style.marginBottom = `-${elementHeight}px`;
            element.closest(PAGE_HERO).style.marginBottom = `${elementHeight}px`;
        });
    } else {
        // Reset margin-bottom for screens smaller than 1023px
        document.querySelectorAll(PAGE_HERO_DESC)?.forEach(element => {
            element.style.marginBottom = "0px";
            element.closest(PAGE_HERO).style.marginBottom = "0px";
        });
    }
}

document.addEventListener("DOMContentLoaded", function() {
    // Initial adjustment
    adjustMarginBottom();

    // Adjust on window resize
    window.addEventListener("resize", adjustMarginBottom);
});